export const sortStringValues = (a?: string | null, b?: string | null) =>
  (a ? a.toLowerCase() : "").localeCompare(b ? b.toLowerCase() : "", undefined, { numeric: true });
